<template>

  <div class="">

    <div class="p-grid report-overview">

      <div class="p-col-12 p-sm-12 p-md-12 p-lg-7">

        <Accordion class="report-accordion p-mb-3">
          <AccordionTab v-for="(value, key) in structure" :key="'accordion_'+key" :header="$t('report.'+key+'.title')">
            <SectionOverview :name="key" :structure="value" :data="report[key]" :domains="domains" :extras="extras" />
          </AccordionTab>

        </Accordion>

        <div class="p-fluid report-field">
          <div class="p-grid report-field-header">
            <div class="p-col p-pt-0 p-pb-0 p-d-flex p-ai-center">
              <label for="global_notes">{{$t('report.RIEPILOGO.note')}}</label>
            </div>
          </div>
          <div>
            <Textarea v-model="note" rows="5" cols="30" :placeholder="$t('report.RIEPILOGO.note_ph')" id="global_notes"
              @input="dataChanged('RIEPILOGO', 'note', $event.target.value)" />
          </div>
        </div>
      </div>

      <div class="p-col-12 p-sm-12 p-md-12 p-lg-5">
        <FileUpload v-if="(role.includes('FACTORY') || role.includes('SERVICE') || role==='SUBSIDIARY')" ref="fileUpload"
          :customUpload="true" :multiple="false" accept="image/jpeg,image/png,application/pdf" :maxFileSize="5000000"
          :fileLimit="1" :disabled="!reportId || images.length>=10 || (status!=null && status!='DRAFT' && status!='REJECTED')" @uploader="uploader"
          :chooseLabel="$t('report.image_choose')" :uploadLabel="$t('report.image_upload')"
          :cancelLabel="$t('report.image_cancel')">

          <template #empty>
            <p v-if="reportId">{{ $t('report.drag_and_drop') }}</p>
            <p v-else>{{ $t('report.drag_and_drop_not_saved') }}</p>
          </template>
        </FileUpload>


        <div class="p-d-flex p-flex-wrap image-gallery p-pb-2">
          <div v-for="(value, index) in imagesBlob" :key="'preview_'+index">
            <Image v-if="!isPdf(value)" :src="value" alt="Image" width="100" height="80"
              preview />
            <span v-else class="p-image p-component p-image-preview-container" @click="viewPdf(value)" v-tooltip.bottom="value.replace(/.*\//, '').replace(/_[0-9]{8}_[0-9]{6}\..*$/, '')">
              <img alt="PDF" width="100" height="80" src="/assets/irinox/icons/pdf.png">
              <div class="p-image-preview-indicator">
                <i class="p-image-preview-icon pi pi-eye"></i>
              </div>
            </span>

            <!-- <Image v-else :src="'/assets/irinox/icons/pdf.png'" alt="Image" width="100" height="80" preview>
              <template #indicatoricon>
                <i class="pi pi-search"></i>
              </template>
            </Image> -->

          </div>

          <span v-if="imagesBlob.length==0" class="p-ml-2">{{ $t('report.no_images') }}</span>
        </div>
      </div>

    </div>

    <div v-if="(role.includes('FACTORY') || role.includes('SERVICE') || role==='SUBSIDIARY')" class="p-d-flex p-jc-start p-pb-4">
      <div class="signature-container p-pb-2">
        <label>{{ $t('report.signature_label') }}</label>
        <div v-if="status==null || status=='DRAFT' || status=='REJECTED'" class="signature">
          <VueSignaturePad ref="signaturePad" :options="{ ...signature.option, ...{ onBegin, onEnd } }"
            :customStyle="signature.style"/>
          <div class="signature-controls p-text-right">
            <Button icon="pi pi-undo" class="p-button-rounded p-button-text p-button-raised p-button-sm" :aria-label="$t('report.signature_back')"
              @click="signatureUndo" />
            <Button icon="pi pi-times" class="p-button-rounded p-button-text p-button-raised p-button-sm" :aria-label="$t('report.signature_delete')"
              @click="signatureClear" />
          </div>
        </div>
        <div v-else class="signature">
          <div class="signature-preview">
            {{ $t('report.signature_not_editable') }}
          </div>
        </div>
      </div>
    </div>

    <!--        -->
    <!-- ERRORS -->
    <!--        -->
    <IrinoxDialogDark :visible="dialog.error" mode="error" :message="$t('report.error_dialog')" :life="3000"
      @update:visible="dialog.error = $event" />
    <IrinoxDialogDark :visible="dialog.success" mode="success" :message="$t('report.upload_image_success')" :life="3000"
      @update:visible="dialog.success = $event" />

    <Dialog v-model:visible="dialog.pdfPreview" modal :header="pdfTitle" :style="{ width: '80vw' }" class="pdf-preview">
      <iframe
        title="PDF Preview"
        :src="pdfUrl"
        width="100%"
        style="border: none; height: 70vh"
      ></iframe>
      <template #footer>
      </template>
    </Dialog>

  </div>

</template>

<script>
import ReportService from '../../service/ReportService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import SectionOverview from './SectionOverview';
import { mapGetters } from 'vuex';

export default {
  emits: ['update:data','update:images','update:signature'],
  components: {
    IrinoxDialogDark,
    SectionOverview,
  },
  props: {
      reportId: String,
      report: Object,
      structure: Object,
      domains: Object,
      extras: Object,
      status: String,
    },
  data() {
    return {
      note: null,
      images: [],
      imagesBlob: [],
      sign: null,
      signature: {
        option: {
          dotSize: (0.5 + 2.5) / 2,
          minWidth: 0.5,
          maxWidth: 1.5,
          throttle: 16,
          minDistance: 5,
          backgroundColor: 'rgba(0,0,0,0)',
          penColor: 'black',
          velocityFilterWeight: 0.7,
        },
        style: { 
          border: '0.5px solid #E7E7E7'
        },
        disabled: false
      },
      dialog: {
        error: false,
        success: false,
        pdfPreview: false,
      },
      pdfUrl: null,
      pdfTitle: null,
    }
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      unit: 'userdata/unit',
      role: 'userdata/role',
      isCelsius: 'userdata/isCelsius',
    }),
  },
  created() {
    this.reportService = new ReportService();
    this.note = this.report["RIEPILOGO"]?.note;
    this.images = this.report["IMAGES"] != null ? this.report["IMAGES"] : [];
    this.imagesBlob = [];
    for(let i=0; i<this.images.length; i++) {
      if(this.isPdf(this.images[i])) {
        this.imagesBlob.push(this.images[i]);
      } else {
        this.downloadImage(this.images[i]);
      }
    }
  },
  mounted() {
  },
  watch: {
  },
  methods: {
    dataChanged(section, key, value) {
      let updatedData = {};
      updatedData.section = section;
      updatedData.key = key;
      updatedData.value = value;
      this.$emit("update:data", updatedData);
    },
    signatureUndo() {
      this.$refs.signaturePad.undoSignature();
      this.signatureChanged();
    },
    signatureClear() {
      this.$refs.signaturePad.clearSignature();
      this.signatureChanged();
    },
    signatureChanged() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      // console.log(isEmpty);
      // console.log(data);
      this.$emit("update:signature", !isEmpty ? data : null);
    },
    uploader(event) {
      console.log("Uploader: " + JSON.stringify(event));
      this.reportService.uploadImage(this.personaltoken, this.reportId, event.files[0])
        .then((data) => {
          if(data.code=='200') {
            this.dialog.success = true;
            this.images.push(data.body);
            this.$refs.fileUpload.clear();
            this.$refs.fileUpload.uploadedFileCount = 0;
            this.$emit("update:images", this.images);
            if(this.isPdf(data.body)) {
              this.imagesBlob.push(data.body);
            } else {
              this.downloadImage(data.body);
            }
          } else {
            console.error("ERROR " + JSON.stringify(data));
            this.dialog.error = true;
          }
        })
        .catch(error => {
          console.error("ERROR " + error);
          this.dialog.error = true;
        });
      
    },
    downloadImage(image) {
      this.reportService.getImage(this.personaltoken, image)
        .then(res => {
          let contentType = res.headers["content-type"];
          let blob=new Blob([res.data], {type: contentType});
          this.imagesBlob.push(URL.createObjectURL(blob));
        })
        .catch(error => {
          console.error("ERROR " + error);
        });
    },
    onBegin() {
      //console.log('=== Begin ===');
    },
    onEnd() {
      //console.log('=== End ===');
      this.signatureChanged();
    },
    isPdf(value) {
      if (typeof value === 'string') {
        return value.endsWith('.pdf');
      } else if (value instanceof Blob) {
        return value.type === 'application/pdf';
      }
    },
    viewPdf(value) {
      this.reportService.getImage(this.personaltoken, value)
        .then(res => {
          const blob = new Blob([res.data], { type: 'application/pdf' });
          this.pdfUrl = URL.createObjectURL(blob);
          if(this.$functions.isMobile()) {
            //apre il pdf in una nuova finestra
            window.open(this.pdfUrl);
          } else {
            //apre il pdf in un iframe nella modale
            this.pdfTitle = value.replace(/.*\//, '');
            this.dialog.pdfPreview = true;
          }
        })
        .catch(error => {
          console.error("ERROR " + error);
          this.dialog.error = true;
        });
    }
  }
}
</script>

<style scoped>

</style>